import {useCallback, useEffect, useState} from 'react';

export interface HistoryClient {
    client: string;
    name: string;
}

const HISTORY_KEY = 'at.ug.selected-client-history';
const MAX_HISTORY = 10;

export function useClientHistory(): [HistoryClient[], (newItem: HistoryClient) => void] {
    const [history, setHistory] = useState<HistoryClient[]>(() => {
        try {
            const raw = localStorage.getItem(HISTORY_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    }, [history]);

    const addToHistory = useCallback((newItem: HistoryClient) => {
        setHistory((prev) => {
            const filtered = prev.filter(
                (h) => !(h.client === newItem.client && h.name === newItem.name)
            );

            const updated = [newItem, ...filtered];

            return updated.slice(0, MAX_HISTORY);
        });
    }, []);

    return [history, addToHistory];
}
